import styled from 'styled-components';

export const Image = styled.img`
  @media only screen and (min-width: 768px) {
    display: block;
  }

  @media only screen and (max-width: 768px) {
    display: none;
  }
`;
